import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { api, type AuditRow } from "../api";

const WORDS: Record<string, string> = {
  "auth.login": "Signed in",
  "auth.refused": "Sign-in refused",
  "project.create": "Created project",
  "project.update": "Changed project",
  "user.role": "Changed role",
};

function detail(r: AuditRow): string {
  const d = r.detail as Record<string, unknown>;
  if (r.action === "user.role") return `${d.from} → ${d.to}`;
  if (r.action === "auth.login") return d.dev ? "development sign-in" : "";
  return Object.entries(d).map(([k, v]) => `${k}: ${String(v).slice(0, 60)}`).join(" · ");
}

export function Audit() {
  const [target, setTarget] = useState("");
  const rows = useQuery({
    queryKey: ["audit", target],
    queryFn: () => api<AuditRow[]>(`/audit?limit=200${target ? `&target=${encodeURIComponent(target)}` : ""}`),
  });
  return (
    <div className="canvas">
      <div className="title-row">
        <div>
          <h1>Audit log</h1>
          <p className="sub">Every sign-in, change and credential reveal, newest first.</p>
        </div>
        <input className="search-field" aria-label="Filter by target" placeholder="project:yms or user:…" value={target} onChange={(e) => setTarget(e.target.value)} />
      </div>
      <section className="panel flush" aria-label="Events">
        {rows.error && <div className="item"><span className="error">{rows.error.message}</span></div>}
        <div className="table-wrap">
          <table>
            <thead><tr><th className="num">When</th><th>Who</th><th>What</th><th>On</th><th className="hide-phone">Detail</th></tr></thead>
            <tbody>
              {rows.data?.map((r) => (
                <tr key={r.id}>
                  <td className="num muted" style={{ whiteSpace: "nowrap" }}>{new Date(r.at).toLocaleString()}</td>
                  <td>{r.actor ?? <span className="muted">—</span>}</td>
                  <td>{WORDS[r.action] ?? r.action}</td>
                  <td className="mono">{r.target}</td>
                  <td className="muted hide-phone truncate" style={{ maxWidth: 360 }}>{detail(r) || "—"}</td>
                </tr>
              ))}
              {rows.data?.length === 0 && <tr><td colSpan={5}><div className="empty">Nothing recorded{target ? ` for ${target}` : ""} yet.</div></td></tr>}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
